<template>
  <div class="session-list">
    <web-socket />
    <div class="login_out">
      <van-popover v-model="showPopover" theme="dark" trigger="click" placement="bottom-end" :actions="actions"
        @select="onSelect">
        <template #reference>
          <van-button type="primary">{{user.name || user.phone || ''}}</van-button>
        </template>
      </van-popover>
    </div>
    <van-pull-refresh v-model="isDownLoading" @refresh="onDownRefresh" :style="{height: freshHeight}">
      <van-list v-model="loading" :finished="finished" :immediate-check="false" :offset="offset" @load="onLoad">
        <div v-if="sessionDataList.length > 0">
          <div v-for="(item, index) in sessionDataList" :key="index" class="all-content">
            <ul>
              <li @click="select(item, index, $event)">
                <van-badge :content="!item.unDisturb && item.unRead" max="99" v-if="!item.unDisturb && item.unRead">
                  <img class="avatar" width="32" height="32"
                    :src="item.avatarUrl || require('@/assets/images/contact_default.png')">
                </van-badge>
                <img v-else class="avatar" width="32" height="32"
                  :src="item.avatarUrl || require('@/assets/images/contact_default.png')">
                <div class="content">
                  <p class="name" v-if="item.type===0 || item.type===3">
                    {{item.memo || item.name}}<span
                      style="font-size: 12px;margin-left:5px;color:#999;">({{item.name}})</span></p>
                  <p class="name" v-if="item.type===1">{{item.name}}</p>
                  <p v-if="item.account&&item.account.qwName" style="margin-left:20px;font-size: 14px;">
                    {{`(${item.account.qwName})`}}</p>
                </div>
                <div v-if="item.account&&item.account.onlineStatus==1" class="right1">在线</div>
                <div v-else class="right">离线</div>
              </li>
            </ul>
          </div>
        </div>
        <van-empty description="暂无会话" v-else />
      </van-list>
    </van-pull-refresh>
  </div>
</template>
<script>
import bus from '@/utils/vueBus.js'
import { cacheStorage } from '@/utils'
import webSocket from './webSocket/index'
/**
 * 聊天工具栏左边的会话列表组件
 */
export default {
  name: 'sessionList',
  props: ['sessionIndex'],
  components: { webSocket },
  data () {
    return {
      sessionDataList: [], // 会话列表
      sessionId: -1, // 当前选中的会话
      keyword: '',
      sessionType: [1, 2, 3], // 1表示我的，2表示别人给我的，3表示分给他人
      handleType: 1, // 批量删除会话或者免打扰弹出框的操作类型：1表示删除会话，2表示免打扰，3表示取消免打扰
      isDownLoading: false, // van组件下拉刷新
      loading: false, // van组件上拉加载
      finished: false, // van组件上拉加载完毕
      offset: 10, // van组件滚动条与底部距离小于 offset 时触发load事件
      currentPage: 1,
      pageSize: 10,
      isEmpty: false,
      showPopover: false,
      // 通过 actions 属性来定义菜单选项
      actions: [{ text: '退出登录' }],
      user: null,
      freshHeight: 0
    }
  },
  methods: {
    //  退出登录
    onSelect (action) {
      if (action.text === "退出登录") {
        cacheStorage.clear()
        // location.href = location.href.split('#')[0] + '?wxCpType=-1&nojum2sso=1'
        let url = process.env.VUE_APP_BASE_URL_WL_LOGOUT + `?redirect_uri=` + location.href.split('#')[0] + '?wxCpType=-1'
        console.log(url, 'url')
        let dload = document.createElement('a')
        dload.href = url
        document.body.appendChild(dload)
        dload.click()
        dload.remove()
      }
    },
    select (item, index, event) {
      this.sessionId = item.id
      // 把未读消息变为0，表示已读
      this.$delete(item, 'unRead')
      // 调用清空未读消息接口
      bus.$emit('wxbClearUnRead', item.id)
      // 打开聊天窗口
      this.$router.push({
        path: '/chatIndex',
        query: {
          type: item.type,
          contactId: item.contactId,
          sessionId: item.id,
          accountId: item.accountId,
          memo: item.memo,
          name: item.name,
        }
      })
    },
    // 获取资源表单列表
    getSessionList () {
      this.$http.get('/scrm/v1/qw-session/m/getAllotSessionList', {
        params: {
          page: this.currentPage,
          pageCount: this.pageSize,
          keyword: this.keyword
        }
      }).then(response => {
        let { data, code, msg } = response
        if (code === 1 && data !== null) {
          this.sessionDataList = this.sessionDataList.concat(data.records)
          if (data.current >= data.pages || data.pages === 0) {
            // 加载结束
            this.finished = true
          }
        }

        this.$nextTick(() => {
          let container = this.$el.querySelector('li:nth-child(5)')
          if (container) {
            container.scrollIntoView()
          }
        })
      }).finally(() => {
        this.isDownLoading = false
        this.loading = false
      })
    },
    // 下拉刷新
    onDownRefresh () {
      this.currentPage = 1
      this.finished = false // 不写这句会导致你上拉到底过后在下拉刷新将不能触发下拉加载事件
      this.sessionDataList = []
      this.getSessionList() // 加载数据
    },
    // 上拉加载请求方法
    onLoad () {
      this.currentPage++
      this.getSessionList()
    },
    // 会话置顶
    handleUp (item, sessionType) {
      bus.$emit('wxbTopSession', { sessionId: item.id, sessionType: sessionType })
    },
    // 会话取消置顶
    handleCancelUp (item, sessionType) {
      bus.$emit('wxbCancelTopSession', { sessionId: item.id, sessionType: sessionType })
    },
    // 会话开启免打扰
    handleDistrub (item, sessionType) {
      bus.$emit('wxbUnDisturbSession', { sessionId: item.id, sessionType: sessionType })
    },
    // 会话关闭免打扰
    handleNoDistrub (item, sessionType) {
      bus.$emit('wxbCancelDisturbSession', { sessionId: item.id, sessionType: sessionType })
    },
    // 删除会话
    handleDelTalk (item, sessionType) {
      bus.$emit('wxbDelSession', { sessionId: item.id, sessionType: sessionType })
    },
  },
  created () {
    this.freshHeight = document.body.clientWidth + "px"
    let userInfo = cacheStorage.getItem(process.env.VUE_APP_USER)
    userInfo = JSON.parse(userInfo)
    this.user = userInfo
    // 消息变化的时候, 会话中未读的消息加1
    bus.$off('wxbUnReadMessageInCrease')
    bus.$on('wxbUnReadMessageInCrease', (value) => {
      // 别人分给我的
      for (let followSessionListKey of this.sessionDataList) {
        // 非当前选中窗口的时候未读消息加1
        if (this.sessionId !== value.sessionId && followSessionListKey.id === value.sessionId) {
          this.$set(followSessionListKey, 'unRead', value.unRead)
        } else if (this.sessionId === value.sessionId && followSessionListKey.id === value.sessionId) {
          // 先在前端清空，然后调用后端接口清空未读消息
          this.$delete(followSessionListKey, 'unRead')
          // 调用清空未读消息接口
          bus.$emit('wxbClearUnRead', value.sessionId)
        }
      }
    })

    // 会话列表 置顶 这里有问题，暂时不做处理
    bus.$off('wxbSessionMoveTop')
    bus.$on('wxbSessionMoveTop', (value) => {
      /*let spliceIndex = 0
      let newSessionIndex = 0
      let firstItem = null
      console.log('打印-----会话置顶：', this.sessionDataList)
      for (let i = 0; i < this.sessionDataList.length; i++) {
          // 计算该会话的下标
          if (this.sessionDataList[i] && this.sessionDataList[i].id === value.sessionId) {
              firstItem = deepCopy(this.sessionDataList[i])
              spliceIndex = i
          }
          // 计算置顶会话的下标
          if (this.sessionDataList[i] && this.sessionDataList[i].topSession === 1) {
              newSessionIndex = i
          }
      }
      if (firstItem !== null) {
          // 截取会话
          this.sessionDataList.splice(spliceIndex, 1)
          // 会话插入
          if (firstItem.topSession) {
              // 置顶会话类型的时候，从置顶数组里面进行置顶
              this.sessionDataList.unshift(firstItem)
          } else {
              // 非置顶会话类型的时候，只能置顶到“置顶数组”的下面
              if (newSessionIndex === 0) {
                  this.sessionDataList.unshift(firstItem)
              } else {
                  this.sessionDataList.splice(newSessionIndex + 1, 0, firstItem)
              }
          }
      }*/
    })

    // 重新加载会话列表
    bus.$off('wxbQuerySession')
    bus.$on('wxbQuerySession', (value) => {
      // 先去 判断一下缓存里面是否有该会话，如果没有则向服务器发送查询会话请求，如果有则不做处理。
      let followFlag = true
      for (let i = 0; i < this.sessionDataList.length; i++) {
        if (this.sessionDataList[i].id === value.sessionId) {
          followFlag = false
          break
        }
      }
      if (followFlag) {
        this.onDownRefresh() // 查询会话列表
        return
      }

      // 未读消息加1
      bus.$emit('wxbUnReadMessageInCrease', value)
      // 会话置顶
      bus.$emit('wxbSessionMoveTop', value)
    })
    // 刷新会话列表
    bus.$off('wxbRefreshSession')
    bus.$on('wxbRefreshSession', (value) => {
      this.onDownRefresh() // 查询会话列表
    })
  },
  /*mounted() {
    this.getSessionList()
  },*/
  activated () {
    this.sessionId = -1
    this.isEmpty = false
    this.onDownRefresh()
  },
}
</script>

<style lang="less" scoped>
.login_out {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 0 15px 0 0;
  /deep/ .van-button--primary {
    color: #1e6eff;
    border: 0;
    background: #fff;
    text-align: right;
  }
}
.session-list {
  li {
    display: flex;
    align-items: center;
    transition: background-color 0.1s;
    &:hover {
      background-color: #fff;
    }
    &.active {
      background-color: #1e6eff !important;
      color: #ffffff !important;
      border-bottom: 0 !important;
      .giveOthers-menu .giveToMe-menu .mineTalk__menu {
        display: block;
      }
    }
  }
  .avatar,
  .name {
    vertical-align: middle;
  }
  .avatar {
    width: 45px;
    height: 45px;
    border-radius: 4px;
  }
  .content {
    display: flex;
    flex-direction: column;
    flex: 1;
  }
  .right {
    color: #999;
    font-size: 14px;
  }
  .right1 {
    color: #1e6eff;
    font-size: 14px;
  }
  .name {
    margin: 0 0 0 20px;
    font-size: 16px;
    line-height: 32px;
    text-overflow: ellipsis; /*当文本溢出时显示…此时还必须定义*/
    white-space: nowrap; /*表示文本不会换行*/
    overflow: hidden; /*表示溢出的内容会被隐藏*/
  }
  .all-content {
    padding: 15px 20px;
    border: 1px solid #eeeeee;
  }
  .van-pull-refresh {
    height: 100vh !important;
  }
}
</style>
